module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-vault-2.212e4739.svg";